import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledContentWrapper = styled.div`
  width: 100%;
  height: auto;
  margin: 0;
  padding: 1px;
  border: 1px solid #d5d9e7;
  border-radius: 5px;
`;

export const StyledHeaderWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 60% 40%;
  grid-gap: 10px;
  align-items: center;
  cursor: pointer;
  padding: 11px 10px;
  margin: 0;
`;

export const StyledHeaderProject = styled.span`
  font-size: ${themeGet('fontSizes.xs')}px;
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.primary.extra')};
`;

export const StyledHeaderBalance = styled.p`
  margin: 0 34px 0 0;
  font-weight: ${themeGet('fontWeights.semiBold')};
  font-size: ${themeGet('fontSizes.xs')}px;
  color: ${themeGet('colors.primary.extra')};
`;

export const StyledHeaderButton = styled.span`
  position: absolute;
  right: 10px;
  display: block;
  align-items: center;
  background-color: ${themeGet('colors.white')};
  cursor: pointer;
  line-height: 1;
  color: ${themeGet('colors.primary.extra')};

  .dropdown-icon {
    transform: rotate(180deg);
  }

  &.active {
    .dropdown-icon {
      transform: rotate(0deg);
    }
  }
`;

export const StyledContainer = styled.div`
  max-height: 150px;
  overflow: scroll;
`;

export const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: 60% 40%;
  grid-gap: 10px;
  justify-content: space-between;
  padding: 0 10px;

  &:not(:last-child) {
    margin-bottom: 6px;
  }
`;

export const StyledProject = styled.span`
  font-size: ${themeGet('fontSizes.xs')}px;
  color: ${themeGet('colors.primary.extra')};
`;

export const StyledBalance = styled.span`
  font-size: ${themeGet('fontSizes.xs')}px;
  color: ${themeGet('colors.primary.extra')};
`;
